var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.9246 12.5142H8.90748C6.55921 12.4519 4.31828 11.4418 2.62858 9.68398C0.996206 7.86537 0.0580213 5.45222 6.77124e-05 2.92324C-0.00339036 2.56897 0.125731 2.22811 0.358339 1.97765L2.01731 0.191821C2.25601 -0.0652424 2.64294 -0.0652424 2.88164 0.191821L5.3267 2.82579C5.56532 3.08293 5.56532 3.49975 5.3267 3.75689L4.35112 4.80587C4.53206 5.53411 4.86536 6.20806 5.32547 6.77608C5.8518 7.27192 6.47661 7.63122 7.15193 7.82637L8.12996 6.77674C8.36865 6.51967 8.75558 6.51967 8.99428 6.77674L11.4393 9.4107C11.678 9.66784 11.678 10.0847 11.4393 10.3418L9.78037 12.1283C9.55417 12.3745 9.24617 12.5134 8.9246 12.5142ZM2.44825 1.58914H2.4452L1.22267 2.90876C1.27251 5.09407 2.0823 7.17954 3.49168 8.75221C4.95164 10.2699 6.88715 11.1422 8.91543 11.1965L10.1422 9.87626L8.55784 8.17406L7.76748 9.02483C7.65441 9.148 7.50039 9.21745 7.33959 9.21777C7.29665 9.21778 7.25383 9.21293 7.21184 9.20328C6.19324 8.96055 5.24747 8.44637 4.46115 7.70784C3.77558 6.86077 3.29828 5.84192 3.07296 4.74463C3.03046 4.52652 3.09325 4.30004 3.23984 4.14277L4.02959 3.29134L2.44825 1.58914Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneWhite);
export default __webpack_public_path__ + "static/media/phone_white.eed32f3d8cc8736a36d54fdb0be3d0ff.svg";
export { ForwardRef as ReactComponent };